import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../../../components/common/SectionHeading';

const Section = styled.section`
  margin-top: 4rem;
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: ${({ theme }) => theme.shadows.md};

  @media (max-width: 768px) {
    padding: 1.75rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
`;

const Card = styled.div`
  border-radius: 1.25rem;
  padding: 2rem;
  background: ${({ theme }) => theme.colors.surfaceMuted};
  transition: ${({ theme }) => theme.transitions.default};
  text-align: center;

  &:hover {
    transform: translateY(-6px);
    box-shadow: ${({ theme }) => theme.shadows.md};
  }
`;

const Number = styled.div`
  font-size: 3rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.5rem;
  font-family: ${({ theme }) => theme.fonts.heading};
`;

const Label = styled.h3`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.text};
`;

const achievements = [
  {
    number: '+16',
    label: '자격증 취득',
  },
  {
    number: '+7',
    label: '전국대회 수상',
  },
  {
    number: '+10',
    label: '코딩발표회',
  },
];

const AchievementsSection = () => (
  <Section id="achievements">
    <SectionHeading
      eyebrow="Achievements"
      title="우리의 성과"
      description="학생들의 노력과 성장이 만들어낸 의미있는 결과들입니다."
    />
    <Grid>
      {achievements.map((achievement) => (
        <Card key={achievement.label}>
          <Number>{achievement.number}</Number>
          <Label>{achievement.label}</Label>
        </Card>
      ))}
    </Grid>
  </Section>
);

export default AchievementsSection;

